import BaseApi from './BaseApi';

class PlanOfMenuApi extends BaseApi {
  delete(id: number, params?: any) {
    return this.del(`/${id}`, params);
  }

  protected getSpecificApiPrefix(): string {
    return 'managers/plans';
  }
}

export default PlanOfMenuApi;
